import { Header, Footer } from "@/components/SitePage";
import { Link } from "@tanstack/react-router";
import type { Lang } from "@/content/site";
import CookieConsent from "@/components/CookieConsent";

type Section = { heading?: string; body: string[] };

export default function LegalPage({
  lang,
  title,
  intro,
  sections,
  updated,
  homeHref,
  backLabel,
}: {
  lang: Lang;
  title: string;
  intro?: string;
  sections: Section[];
  updated: string;
  homeHref: string;
  backLabel: string;
}) {
  return (
    <>
      <Header lang={lang} />
      <main className="bg-[oklch(0.98_0.01_95)] pt-28 pb-20">
        <article className="mx-auto max-w-3xl px-5">
          <p className="text-[11px] uppercase tracking-[0.22em] text-emerald-deep/70 font-semibold">
            {lang === "en" ? "Legal" : "Legal"}
          </p>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight text-emerald-deep mt-3">
            {title}
          </h1>
          <p className="mt-3 text-xs uppercase tracking-widest text-emerald-deep/60">
            {lang === "en" ? "Last updated" : "Última actualização"}: {updated}
          </p>
          {intro && (
            <p className="mt-6 text-base leading-relaxed text-emerald-deep/85">{intro}</p>
          )}
          <div className="mt-8 space-y-8">
            {sections.map((s, i) => (
              <section key={i}>
                {s.heading && (
                  <h2 className="font-display text-xl md:text-2xl text-emerald-deep tracking-tight">
                    {s.heading}
                  </h2>
                )}
                <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-emerald-deep/85">
                  {s.body.map((p, j) => (
                    <p key={j} dangerouslySetInnerHTML={{ __html: p }} />
                  ))}
                </div>
              </section>
            ))}
          </div>
          <div className="mt-12 pt-6 border-t border-emerald-deep/10">
            <Link to={homeHref} className="text-sm text-emerald-deep hover:text-gold transition-colors">
              ← {backLabel}
            </Link>
          </div>
        </article>
      </main>
      <Footer lang={lang} />
      <CookieConsent lang={lang} />
    </>
  );
}